import { Component, Inject, ViewEncapsulation, OnInit, Injector } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { statusSchedule } from 'app/core/data/calendar.json';
import { scheduleI, scheduleStatus, rescheduleI } from 'app/core/interfaces/schedule';
import * as moment from 'moment';
import { DialogData } from 'app/core/interfaces/dialog';
import { MaterialDialog } from 'app/modules/shared/components/dialog/dialog.component';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatCalendarCellClassFunction, MatDatepickerInputEvent } from '@angular/material/datepicker';
import { addressI } from 'app/core/interfaces/adress';
import { organizationI } from 'app/core/interfaces/organization';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { EncounterService } from 'app/core/http/services/encounter.service';
import { ScheduleService } from 'app/core/http/services/schedule.service';
import { PatientService } from 'app/core/http/services/patient.service';
import { telecom } from 'app/core/models/Organization';
import { OrganizationLocationService } from 'app/core/http/services/organization-location.service';
import { Encounter } from 'app/core/interfaces/encounter';
import { TimeSlot } from 'app/core/interfaces/practitionerHours';
import { PractitionerOrganizationAffiliationService } from 'app/core/http/services/practititoner-organization-affiliation.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Practitioner } from 'app/core/interfaces/practitioner';
import { PractitionerService } from 'app/core/http/services/practitioner.service';

@Component({
  selector: 'page-schedule-details',
  templateUrl: './schedule-details.component.html',
  styleUrls: ['./schedule-details.component.scss'],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'pt-BR' }],
  encapsulation: ViewEncapsulation.None,
})
export class PractitionerScheduleDetailsComponent extends BaseComponent implements OnInit {
  public mock: scheduleI[] = [];
  public status = 0;
  public horariosExame = 10;
  public horariosConsulta = 10;
  public scheduleStatus: scheduleStatus[] = statusSchedule;
  public titleDados = 'Dados do Paciente';
  public titleReschedule = 'Reagendamento';
  public scheduleHorarios = [];
  public address: addressI = <addressI>{};
  public organization: any = <organizationI>{};
  public hours: any[] = [];
  public dates: any[] = [];
  public hour: rescheduleI = <rescheduleI>{};
  public organizationLocation: any;
  public latLong: [number, number] = [0, 0];
  public weeklySchedule: any = {};
  public disabledTimes: any[] = [];
  public encountersDone: any = {};
  public dayOfWeekSelected: string = '';
  public encounterPractitioner!: Encounter[];
  public uploadedFiles: { name: string; base64: string }[] = [];
  public isDragging = false;
  public encounterFHIR: any;
  public encounter: any;
  public scheduleFHIR: any;
  public schedule: any;
  public type: string = '';
  public patient: any;
  public isSaving = false;

  public daysOfWeek = ['Domingo', 'Segunda', 'Terca', 'Quarta', 'Quinta', 'Sexta', 'Sabado'];
  public blockedDates: string[] = [];

  public isByOrder: Boolean = false;
  public practitioner_id: string = '';
  public practitioner!: Practitioner;

  constructor(
    public dialogRef: MatDialogRef<MaterialDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private injector: Injector,
    private encounterService: EncounterService,
    private scheduleService: ScheduleService,
    private patientService: PatientService,
    private organizationLocationService: OrganizationLocationService,
    private affiliationOrganizationPractitioner: PractitionerOrganizationAffiliationService,
    private practitionerService: PractitionerService,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    let parameters = this.data.param;

    if (parameters.encounter) {
      this.encounter = parameters.encounter as Encounter;
      this.encounterFHIR = parameters.encounterFHIR;

      this.type = 'encounter';

      this.isByOrder = this.encounter.byOrderInfo?.isByOrder;
    }

    this.practitioner_id = this.encounter.practitioner.practitioner_id;

    this.getPractitioner();
    this.getPatient();
    this.getEncounterByPractitioner(this.practitioner_id);
    this.getOrganizationLocation();
    this.getHoursOfOperation();
  }

  dateFilter = (d: Date | null): boolean => {
    if (!d) return false;

    const date = moment(d).format('YYYY-MM-DD');
    if (this.blockedDates.includes(date)) return false;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const dayOfWeek = d.getDay();
    const dayName = this.getDayName(dayOfWeek);
    const hasSlots = this.weeklySchedule[dayName] && this.weeklySchedule[dayName].length > 0;

    return hasSlots && d >= today;
  };

  disabledMinuts = (selectedHour: string) => {
    const dateIso = moment(this.hour.date).format('YYYY-MM-DD');
    const dateTime = `${dateIso} ${selectedHour}:00`;
    const dateSelected = moment(dateTime, 'YYYY-MM-DD HH:mm:ss');
    const currentDate = moment();

    return dateSelected.isBefore(currentDate);
  };

  getDayName(dayOfWeek: number): string {
    return this.daysOfWeek[dayOfWeek];
  }

  isOrganizationDealer() {
    return this.encounter.organization.organization_id == this.encounter.practitioner.practitioner_id;
  }

  isSpecialistDealer() {
    return this.encounter.organization.organization_id != this.encounter.practitioner.practitioner_id;
  }

  private getPractitioner(): void {
    this.practitionerService.showNew(this.practitioner_id).subscribe({
      next: (practitioner) => {
        this.practitioner = practitioner;

        const days = Array.isArray(practitioner.modifiedDays) ? practitioner.modifiedDays : [];
        this.blockedDates.push(...days.map((d) => new Date(d.date).toISOString().split('T')[0]));
      },
      error: (err) => console.log(err),
    });
  }

  getPatient() {
    const patient_id = this.encounter.patient.patient_id;

    this.patientService.show(patient_id).subscribe({
      next: (resPatient: any) => {
        this.patient = resPatient;

        let address = this.patient?.address[0] ? this.patient?.address[0] : this.patient?.address;
        this.patient.address = this.formatAddress(address);

        const contact = this.extractContactInfo(this.patient.telecom ?? []);

        if (contact) {
          this.patient.phone = contact?.phone ?? '';
          this.patient.mobile = contact?.mobile ?? '';
          this.patient.mail = contact?.email ?? '';
        }

        this.patient.cpf = this.patient?.identifier[0]?.value;
      },
      error: (err) => {
        console.log('ERRO', err);
      },
    });
  }

  onDateChange(event: MatDatepickerInputEvent<Date>) {
    const daysOfWeek = ['Domingo', 'Segunda', 'Terca', 'Quarta', 'Quinta', 'Sexta', 'Sabado'];
    const selectedDate = event.value;

    if (selectedDate) {
      const date = moment(this.hour.date).format('YYYY-MM-DD');
      this.disabledTimes = this.encountersDone[date];

      const dayIndex = selectedDate.getDay();
      this.dayOfWeekSelected = daysOfWeek[dayIndex];

      this.getHoursOfOperation();
    } else {
      this.hours = [];
    }
  }

  generateTimeSlots(dayOfWeek: number, startHour: string, endHour: string, slotDuration: number): TimeSlot[] {
    let slots: TimeSlot[] = [];

    let startTime = new Date(`1970-01-01T${startHour}:00`);
    const endTime = new Date(`1970-01-01T${endHour}:00`);

    while (startTime < endTime) {
      let endTimeSlot = new Date(startTime.getTime() + slotDuration);

      if (endTimeSlot <= endTime) {
        slots.push({
          dayOfWeek,
          timeStart: startTime.toTimeString().slice(0, 5),
          timeEnd: endTimeSlot.toTimeString().slice(0, 5),
        });
      }

      startTime = endTimeSlot;
    }

    return slots;
  }

  getDayOfWeek(dia: string): number {
    const daysOfWeek: { [key: string]: number } = {
      Segunda: 1,
      Terca: 2,
      Quarta: 3,
      Quinta: 4,
      Sexta: 5,
      Sabado: 6,
      Domingo: 0,
    };
    return daysOfWeek[dia];
  }

  getHoursOfOperation() {
    const encounter = this.encounter as Encounter;
    const organizationId = encounter.organization.organization_id;
    const practitionerId = encounter.practitioner.practitioner_id;

    this.weeklySchedule = {};
    this.hours = [];

    const averageDuration = (this.encounter.averageDuration ?? 30) as number;
    const slotDuration = averageDuration * 60 * 1000;

    this.affiliationOrganizationPractitioner.listByPractitionerOrganization(organizationId, practitionerId).subscribe({
      next: (affiliation: any) => {
        const practitionerHours = affiliation.specialty.filter((specialty: any) => specialty.id === this.encounter.specialty_code);

        practitionerHours[0].practitionerHours.forEach((dayInfo: any) => {
          if (dayInfo.active) {
            const dayOfWeek = this.getDayOfWeek(dayInfo.dia);
            const { hours } = dayInfo;

            this.weeklySchedule[dayInfo.dia] = [];

            hours.forEach((hour: any) => {
              const timeSlots = this.generateTimeSlots(dayOfWeek, hour.startHour, hour.endHour, slotDuration);
              this.weeklySchedule[dayInfo.dia].push(...timeSlots);
            });
          }
        });

        if (this.dayOfWeekSelected) {
          this.hours = this.weeklySchedule[this.dayOfWeekSelected];
        }
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  getOrganizationLocation() {
    const organizationId = this.encounter.organization.organization_id;

    this.organizationLocationService.showByOrganization(organizationId).subscribe({
      next: (resOrganizationLocation) => {
        this.organizationLocation = resOrganizationLocation;

        let address = this.organizationLocation?.address[0] ? this.organizationLocation?.address[0] : this.organizationLocation?.address;
        this.organizationLocation.address = this.formatAddress(address);

        this.latLong = [this.organizationLocation.position.latitude ?? 0, this.organizationLocation.position.longitude ?? 0];

        const days = Array.isArray(this.organizationLocation.organization.modifiedDays) ? this.organizationLocation.organization.modifiedDays : [];
        this.blockedDates.push(...days.map((d: any) => new Date(d.date).toISOString().split('T')[0]));
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  getEncounterByPractitioner(practitionerId: string) {
    this.encountersDone = [];

    this.encounterService.listByPractitionerNew(practitionerId).subscribe({
      next: (encounter: Encounter[]) => {
        this.encounterPractitioner = encounter;

        encounter.forEach((encounter: Encounter) => {
          const [date, time] = encounter.startDate.split(' ');

          if (!this.encountersDone[date]) {
            this.encountersDone[date] = [];
          }

          this.encountersDone[date].push(time);
        });
      },
      error: (err) => {
        console.log('Falha ao buscar as organizações', err);
      },
    });
  }

  saveDiagnosis() {
    this.isSaving = true;

    const encounterData = {
      ...this.encounterFHIR,
      diagnosis: this.encounter.diagnosis,
    };

    this.encounterService.updateNew(this.encounterFHIR.encounter_id, encounterData).subscribe({
      next: (resSchedule: any) => {
        this.isSaving = false;
        this.showErrorMessage = false;
        this.showSuccessMessage = true;
      },
      error: (err) => {
        console.log('error', err);
        this.isSaving = false;
        this.showErrorMessage = true;
        this.showSuccessMessage = false;
      },
    });
  }

  reagendamento() {
    if (!this.hour.date) {
      return;
    }

    const content = this.isByOrder
      ? `Deseja reagendar o atendimento para o dia <b>${moment(this.hour.date).format('DD/MM/YYYY')}</b>? Lembre-se que o atendimento é por horario de chegada`
      : `Deseja reagendar o atendimento para <b>${moment(this.hour.date).format('DD/MM/YYYY')} ${this.hour.time}</b>?`;
    this.layout
      .openDialog({
        showButtonCancel: true,
        buttonText: 'salvar',
        title: 'Confirmar reagendamento',
        content: content,
      })
      .subscribe((retorno: any) => {
        if (retorno) {
          const startDate = this.isByOrder
            ? moment(this.hour.date).format('YYYY-MM-DD') + ' ' + this.getFirstAvailableSlot()
            : moment(this.hour.date).format('YYYY-MM-DD') + ' ' + this.hour.time;

          if (!startDate) return;

          this.confirmReagendamento(startDate);
        }
      });
  }

  textForProcedureByOrder() {
    let text = `O atendimento deste procedimento é realizado por ordem de chegada.</b> `;

    return text;
  }

  getFirstAvailableSlot(): string | null {
    const selectedDate = moment(this.hour.date).format('YYYY-MM-DD');
    const dayName = this.getDayName(moment(this.hour.date).day());

    const encountersDoneForDate = this.encountersDone[selectedDate] || [];

    const availableSlots = this.weeklySchedule[dayName]?.filter((slot: any) => !encountersDoneForDate.includes(slot.timeStart)) || [];

    if (availableSlots.length === 0) {
      this.openSnackBar('Ops! Parece que não há mais vagas disponíveis para esse dia.', 'warning');
      return null;
    }

    const firstAvailableSlot = availableSlots[0];

    return firstAvailableSlot.timeStart;
  }

  confirmReagendamento(dateStart: string) {
    const encounter = this.encounter as Encounter;

    encounter.startDate = dateStart;

    this.encounterService.updateNew(encounter.encounter_id!, encounter).subscribe({
      next: (resEncounter) => {
        this.openSnackBar('Reagendamento realizado com sucesso!', 'success');
        this.dialogRef.close(true);
      },
      error: (err: HttpErrorResponse) => {
        console.error('errr', err);

        this.openSnackBar('Falha ao realizar reagendamento! ' + err, 'error');
      },
    });
  }

  dateClass: MatCalendarCellClassFunction<Date> = (cellDate, view) => {
    // Only highligh dates inside the month view.
    if (view === 'month') {
      const date = cellDate.getDate();
      // Highlight the 1st and 20th day of each month.
      return date === 1 || date === 20 ? 'warning-date' : '';
    }
    return '';
  };

  public cancelSchedule() {
    let text = '<b>Exame/Consulta:</b> ';
    if (this.encounter) {
      text += this.encounter.name;
    }
    text += `<br/><b>Data/Hora:</b> ${this.layout.dateTimeFormat(this.encounter?.startDate)}`;
    this.layout
      .openDialog({
        showButtonCancel: true,
        buttonText: 'Cancelar atendimento',
        title: 'Deseja cancelar o atendimento?',
        content: text,
      })
      .subscribe((retorno: any) => {
        if (retorno) {
          this.removeSchedule();
          this.dialogRef.close();
        }
      });
  }

  formatAddress(address: any) {
    if (!address) {
      return [];
    }

    const extraInfos = address?.line ?? [];

    return {
      cep: address.postalCode ?? address.cep,
      city: address.city,
      country: address.country,
      state: address.state,
      street: extraInfos[0] ?? 'Undefined',
      number: extraInfos[1] ?? 'Undefined',
      complement: extraInfos[2] ?? 'Undefined',
    };
  }

  extractContactInfo(telecom: telecom[]) {
    let email: string | null = null;
    let phone: string | null = null;
    let mobile: string | null = null;

    telecom.forEach((telecom) => {
      const { value, use, system } = telecom;

      if (system === 'email') {
        email = value;
      } else if (system === 'phone') {
        phone = value;
      } else if (system === 'mobile') {
        mobile = value;
      }
    });

    return { email, phone, mobile };
  }

  public removeSchedule() {
    const encounter = this.encounter as Encounter;

    encounter.status = 'cancelled';

    this.encounterService.updateNew(encounter.encounter_id!, encounter).subscribe({
      next: (resEncounter) => {
        this.openSnackBar('Agendamento cancelado com sucesso!', 'success');
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.openSnackBar('Falha ao cancelar agendamento!', 'error');
        console.log('error', err);
      },
    });
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false; // Remover o estado de "arrastar ativo"

    if (event.dataTransfer?.files && event.dataTransfer.files.length > 0) {
      const files = Array.from(event.dataTransfer.files);

      files.forEach((file) => {
        const reader = new FileReader();
        reader.onload = () => {
          if (reader.result) {
            const base64 = reader.result.toString().split(',')[1]; // Pegar apenas o conteúdo base64
            this.uploadedFiles.push({ name: file.name, base64 });
          }
        };
        reader.readAsDataURL(file); // Ler o arquivo como Data URL
      });
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      Array.from(input.files).forEach((file) => {
        const reader = new FileReader();
        reader.onload = () => {
          if (reader.result) {
            const base64 = reader.result.toString();
            this.uploadedFiles.push({ name: file.name, base64 });
          }
        };
        reader.readAsDataURL(file); // Ler o arquivo como Data URL
      });
    }
  }

  removeFile(index: number): void {
    this.uploadedFiles.splice(index, 1);
  }

  viewDocument(fileUrl: string): void {
    if (fileUrl) {
      window.open(fileUrl, '_blank'); // Abre o arquivo (ou a URL) em uma nova aba
    } else {
      console.error('URL inválida');
    }
  }

  formatPhone(value?: string): string {
    if (!value) return '';
    let digits = String(value).replace(/\D/g, '');
    if (digits.length > 11 && digits.startsWith('55')) digits = digits.slice(2);
    if (digits.length === 11) return digits.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    if (digits.length === 10) return digits.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    return value;
  }
}
